/**
 * ## Configuration Controller
 *
 * @module src/controllers/configuration
 */

"use strict";

const chart = require("../../components/chart");
const chartcon = require("../../controllers/chart");
const component = require("../../components/component");
const modal = require("../../components/modal");
const accordion = require("../../components/accordion");
const notification = require("../../components/notification");
const reslimit = require("../../controllers/reslimit");
const layout = require("../../components/layout");
const conf = require("../../config");
const l = require("../../common").localization;

const headerHeight = 50;
let currentConfig = null;
let chartObj = [];

/** Configuration
 */

const genCharts = (kd, chart_name) => {
  chartObj = [];
  if (kd.usage === "x_chart") {
    $("#layout_chart_control").css("display", "none");
  } else {
    $("#layout_chart_control").css("display", "block");
  }
  $("#layout_chart_control_select").html(chart_name);
  const charts = Object.assign([], kd.find("chart", { active: 1 })).reverse();
  for (let i = 0; i < charts.length; ++i) {
    if (!charts[i].hasOwnProperty("name")) {
      charts[i].name = `${l.translate("Seat Map")} ${i + 1}`;
    }
    chartObj.push({
      description: charts[i].name,
      value: charts[i]._id,
    });
  }
  return chartObj;
};

const init = (kd) => {
  const location = kd.doc("location")[0];
  let template_id = location.template;
  const charts_id = location.chart;
  let template_name = kd.doc("template", template_id)[0].name;
  let chart_name = kd.doc("chart", charts_id)[0].name;
  if (!chart_name) {
    chart_name = `${l.translate("Seat Map")} 1`;
  }
  if (kd.usage == "x_chart" || kd.usage == "g_chart") {
    currentConfig = "seatmap";
  } else if (kd.usage == "x_section" || kd.usage == "g_section") {
    currentConfig = "section";
  }

  kd.on("location.update", (data) => {});

  if (currentConfig === "seatmap" || currentConfig === "section") {
    genCharts(kd, chart_name);
  }

  $("#layout_chart_control_select").fastClick((e) => {
    const options = {
      target_id: "layout_chart_control_select",
      type: "dropdown",
      position: "top",
      highlight: null,
      adjust: {
        x: -20,
        y: -20,
      },
    };
    component.create(options, chartObj, (err, value) => {
      const opt = {
        position: "top",
        width: "90%",
        seconds: 0,
        h1: l.translate("Are you sure you want to change to this seat map?"),
        body: l.translate("Any unsaved changes will be lost"),
        buttons: [
          {
            description: "Cancel",
            value: "cancel",
          },
          {
            description: "Proceed",
            value: "proceed",
          },
        ],
      };
      notification.create(opt, {}, (err7, value2) => {
        if (!err7 && value2 === "proceed") {
          $("#layout_chart_control_select").html(value.description);
          const loc5 = kd.doc("location")[0];
          loc5.chart = value.value;
          loc5.template = kd.find("template", { chart: value.value })[0]._id;
          kd.location.template = loc5.template;
          kd.templatedata = Object.assign(
            {},
            kd.doc("template", loc5.template)[0]
          );
          kd.chartdata = Object.assign({}, kd.doc("chart", value.value)[0]);
          chart.chartdata = kd.chartdata;
          chartcon.chart = kd.chartdata;
          kd.emit("template.update", {});
          kd.emit("chart.update", {});
          if (currentConfig === "section") {
            setTimeout(() => {
              $("#layout_chart_template_select").click();
              setTimeout(() => {
                $("#dd1").click();
              }, 50);
            }, 50);
          }
        }
        notification.destroy();
      });
    });
  });

  $("#layout_chart_control_add").fastClick((e) => {
    const opt = {
      width: "80%",
      type: "dialog",
      h1: "New Seat Map",
      body: `${l.translate(
        "Please enter the name of your new seat map."
      )}</br></br>\
            ${l.translate(
              "Please note: " +
                "Section templates " +
                "(colors on the tables) are not copied as a part of this process. If you create a " +
                "copy of this chart, the section templates will not copy over and they will have to " +
                "be created after you save the copied chart in the section editor."
            )}`,
      fields: [
        {
          description: l.translate("Seat Map Name"),
        },
      ],
      buttons: [
        {
          description: l.translate("Cancel"),
          value: "cancel",
        },
        {
          description: l.translate("Create Copy of Current Chart"),
          value: "clone",
        },
        {
          description: l.translate("Create Blank Chart"),
          value: "blank",
        },
      ],
    };

    const data = {
      kd,
    };
    modal.create(opt, data, (err, value) => {
      let pass = true;
      let newChart = {};
      const charts = kd.find("chart", { active: 1 });

      for (let i = 0; i < charts.length; ++i) {
        if (
          charts[i].hasOwnProperty("name") &&
          value.fields[0] === charts[i].name
        ) {
          pass = false;
        }
      }
      if (pass || value.button === "cancel") {
        modal.destroy();
        if (value.button === "clone" && value.fields[0] !== "") {
          // create chart, then matching template assigned to chart
          const tables = kd.chartdata.tables;
          newChart = {
            domain: "chart",
            name: value.fields[0],
            rooms: kd.chartdata.rooms,
            tables: kd.chartdata.tables,
            active: 1,
          };
        } else if (value.button === "blank" && value.fields[0] !== "") {
          newChart = {
            domain: "chart",
            name: value.fields[0],
            rooms: [
              {
                id: 1,
                name: "Main",
              },
            ],
            tables: [],
            active: 1,
          };
        }
        if (value.button !== "cancel" && value.fields[0] !== "") {
          let newChartID = 0;
          kd.update(newChart)
            .then((result2) => {
              newChartID = result2._id;
              const newTemplate = {
                domain: "template",
                name: `${l.translate("Primary")}`,
                tables: [],
                active: 1,
                order: 1,
                chart: result2._id,
              };
              return kd.update(newTemplate);
            })
            .then((result3) => {
              const proposed = {
                domain: "location",
                _id: location._id,
                chart: newChartID,
                template: result3._id,
              };
              return kd.update(proposed);
            })
            .then((result4) => {
              kd.chartdata = kd.doc("chart", newChartID)[0];
              genCharts(kd, value.fields[0]);
              kd.emit("chart.update", {});
            })
            .catch((err4) => {
              console.log("err4", err4);
            });
        }
      } else {
        const opt5 = {
          position: "top",
          width: "90%",
          seconds: 3,
          h1: l.translate("Room name already exists"),
          body: l.translate("Please choose a unique name for this room."),
          buttons: [
            {
              description: "ok",
              value: "close",
            },
          ],
        };
        notification.create(opt5, {}, (err2, value2) => {
          notification.destroy();
        });
      }
    });
  });

  $("#layout_chart_control_remove").fastClick((e) => {
    const charts = Object.assign([], kd.find("chart", { active: 1 }));
    if (charts.length < 2) {
      const opt = {
        position: "top",
        width: "90%",
        seconds: 0,
        h1: l.translate("Can not delete seat map"),
        body: l.translate("At least one seat map must exist."),
        buttons: [
          {
            description: "Ok",
            value: "cancel",
          },
        ],
      };
      notification.create(opt, {}, (err, value) => {
        notification.destroy();
      });
    } else {
      const opt = {
        width: "80%",
        type: "dialog",
        h1: "Delete Seat Map",
        body: l.translate(
          "Are you sure you want to remove this seat map? All templates " +
            "associated with this seat map will also be deleted."
        ),
        buttons: [
          {
            description: l.translate("Cancel"),
            value: "cancel",
          },
          {
            description: l.translate("Yes, delete this seat map"),
            value: "delete",
          },
        ],
      };

      const data = {
        kd,
      };
      modal.create(opt, data, (err, value) => {
        modal.destroy();
        if (value.button === "delete") {
          const templates = kd.find("template", {
            $and: [{ active: 1 }, { chart: kd.location.chart }],
          });
          for (let i = 0; i < templates.length; ++i) {
            const removeTemplates = {
              domain: "template",
              _id: templates[i]._id,
              active: 2,
            };
            kd.update(removeTemplates)
              .then((result4) => {})
              .catch((err4) => {
                console.log("err4", err4);
              });
          }
          const removeChart = {
            domain: "chart",
            active: 2,
            _id: kd.location.chart,
          };
          let chartone;
          kd.update(removeChart)
            .then((result4) => {
              chartone = Object.assign(
                [],
                kd.find("chart", { active: 1 })
              ).reverse();
              const locationUpdate = {
                domain: "location",
                _id: kd.location._id,
                chart: chartone[0]._id,
              };
              return kd.update(locationUpdate);
            })
            .then((result5) => {
              kd.chartdata = kd.doc("chart", chartone[0]._id)[0];
              genCharts(kd, chartone[0].name);
              kd.emit("chart.update", {});
            })
            .catch((err4) => {
              console.log("err4", err4);
            });
        }
      });
    }
  });

  $("#layout_configuration_header_close").fastClick((e) => {
    closeWarn(kd);
  });

  const configdrop = [
    {
      description: "Seat Map Editor",
      value: "seatmap",
    },
    {
      description: "Section Editor",
      value: "section",
    },
    {
      description: "Reservation Limits",
      value: "reservations",
    },
  ];

  $("#layout_configuration_header_h1").fastClick((e) => {
    const options = {
      target_id: e.target.id,
      type: "dropdown",
      position: "bottom",
      highlight: null,
      adjust: {
        x: 0,
        y: 3,
      },
    };
    component.create(options, configdrop, (err, value) => {
      currentConfig = value.value;

      $("#layout_configuration_header_h1")
        .html(`<i class="fa fa-cog fa-lg"></i>&nbsp;&nbsp;\
                ${value.description} <i class="fa fa-angle-down fa-lg"></i>`);
      switch (value.value) {
        case "seatmap":
          chartOpen(kd);
          break;
        case "section":
          sectionOpen(kd);
          break;
        default:
          chartClose(kd);
          TweenMax.to("#layout_configuration", 1, {
            height: $(window).height(),
            ease: Power2.easeOut,
          });
          break;
      }
    });

    /*
        block.filter('layout_sidebar_content_standard', 'in');
        */
  });

  $("#layout_chart_clear").fastClick((event) => {
    const opt = {
      position: "top",
      width: "90%",
      seconds: 0,
      h1: l.translate("Are you sure you want to clear this room?"),
      body: l.translate(
        "This will remove all the tables and icons from this room and " +
          "is not undoable."
      ),
      buttons: [
        {
          description: "Clear it",
          value: "clear",
        },
        {
          description: "Cancel",
          value: "cancel",
        },
      ],
    };
    notification.create(opt, {}, (err, value) => {
      if (value == "clear") {
        const chart_id = kd.doc("location")[0].chart;
        const tables = kd.chartdata.tables;
        for (let i = tables.length - 1; i >= 0; --i) {
          if (kd.localstore.data.room == tables[i].room) {
            tables.splice(i, 1);
          }
        }
        kd.update({
          _id: chart_id,
          domain: "chart",
          _kd: {
            mergerule: "REPLACE",
          },
          tables,
        });

        kd.emit("chart.update", {});
      }
      notification.destroy();
    });
  });

  $("#layout_chart_add").fastClick((event) => {
    switch (currentConfig) {
      case "seatmap": {
        const opt = {
          width: "80%",
          type: "dialog",
          h1: "Add Room",
          body: l.translate(
            "Please enter the name of the new room in your seating chart."
          ),
          fields: [
            {
              description: l.translate("Room Name"),
            },
          ],
          buttons: [
            {
              description: l.translate("Cancel"),
              value: "cancel",
            },
            {
              description: l.translate("Add Room"),
              value: "addRoom",
            },
          ],
        };

        const data = {
          kd,
        };
        modal.create(opt, data, (err, value) => {
          let pass = true;
          for (let i = 0; i < kd.chartdata.rooms.length; ++i) {
            if (value.fields[0] === kd.chartdata.rooms[i].name) {
              pass = false;
            }
          }
          if (pass || value.button === "cancel") {
            modal.destroy();
            if (value.button != "cancel" && value.fields[0]) {
              const chart_id = kd.doc("location")[0].chart;
              let room_id = 0;
              for (let i = 0; i < kd.chartdata.rooms.length; ++i) {
                if (kd.chartdata.rooms[i].id > room_id) {
                  room_id = kd.chartdata.rooms[i].id;
                }
              }

              ++room_id;

              kd.chartdata.rooms.push({
                id: room_id,
                name: value.fields[0],
              });

              kd.update({
                _id: chart_id,
                domain: "chart",
                _kd: {
                  mergerule: "REPLACE",
                },
                rooms: Object.assign([], kd.chartdata.rooms),
              });
            }
          } else {
            const opt5 = {
              position: "top",
              width: "90%",
              seconds: 3,
              h1: l.translate("Room name already exists"),
              body: l.translate("Please choose a unique name for this room."),
              buttons: [
                {
                  description: "ok",
                  value: "close",
                },
              ],
            };
            notification.create(opt5, {}, (err2, value2) => {
              notification.destroy();
            });
          }
        });
        break;
      }
      case "section": {
        const opt = {
          width: "80%",
          type: "dialog",
          h1: l.translate("Create New Template"),
          body: l.translate("Please enter the name of the new template."),
          fields: [
            {
              description: l.translate("Template Name"),
            },
          ],
          buttons: [
            {
              description: l.translate("Cancel"),
              value: "cancel",
            },
            {
              description: l.translate("Add Template"),
              value: "addTemplate",
            },
          ],
        };

        const data = {
          kd,
        };
        modal.create(opt, data, (err, value) => {
          const templates = Object.assign(
            [],
            kd.find("template", {
              $and: [{ active: 1 }, { chart: kd.location.chart }],
            })
          );
          let pass = true;
          for (let i = 0; i < templates.length; ++i) {
            if (value.fields[0] === templates[i].name) {
              pass = false;
            }
          }
          if (pass || value.button === "cancel") {
            modal.destroy();
            if (value.button != "cancel" && value.fields[0]) {
              let order = 0;
              for (let i = 0; i < templates.length; ++i) {
                if (order < templates[i].order) {
                  order = templates[i].order;
                }
              }
              kd.update({
                domain: "template",
                name: value.fields[0],
                chart: kd.location.chart,
                tables: [],
                active: 1,
                order: ++order,
              });
              setTimeout(() => {
                $("#layout_chart_template_select").click();
                setTimeout(() => {
                  $(".dropdownitem").last().click();
                }, 1);
              }, 500);
              const opt2 = {
                position: "top",
                width: "90%",
                seconds: 3,
                h1: l.translate("Template Added"),
                body: "",
                buttons: [
                  {
                    description: "ok",
                    value: "close",
                  },
                ],
              };
              notification.create(opt2, {}, (err2, value2) => {
                notification.destroy();
              });
            }
          } else {
            const opt5 = {
              position: "top",
              width: "90%",
              seconds: 3,
              h1: l.translate("Template name already exists"),
              body: l.translate(
                "Please choose a unique name for this template."
              ),
              buttons: [
                {
                  description: "ok",
                  value: "close",
                },
              ],
            };
            notification.create(opt5, {}, (err2, value2) => {
              notification.destroy();
            });
          }
        });
        break;
      }
      default:
        break;
    }
  });

  $("#layout_chart_edit").fastClick((event) => {
    switch (currentConfig) {
      case "seatmap": {
        const room_id = kd.localstore.data.room;

        const chart_id = kd.doc("location")[0].chart;
        const rooms = kd.doc("chart", chart_id)[0].rooms;
        let room_name = "";

        for (let i = 0; i < rooms.length; ++i) {
          if (rooms[i].id == room_id) {
            room_name = rooms[i].name;
            break;
          }
        }

        const opt = {
          width: "90%",
          type: "dialog",
          h1: l.translate("Edit Room"),
          body: l.translate(
            "Please enter a new name for this room. You can alternatively " +
              "delete this room altogether."
          ),
          fields: [
            {
              description: room_name,
            },
          ],
          buttons: [
            {
              description: l.translate("Cancel"),
              value: "cancel",
            },
            {
              description: l.translate("Delete Room"),
              value: "deleteRoom",
            },
            {
              description: l.translate("Rename Room"),
              value: "renameRoom",
            },
          ],
        };

        const data = {
          kd,
        };
        modal.create(opt, data, (err, value) => {
          switch (value.button) {
            case "renameRoom":
              if (value.fields[0].length) {
                let pass = true;
                for (let i = 0; i < kd.chartdata.rooms.length; ++i) {
                  if (value.fields[0] === kd.chartdata.rooms[i].name) {
                    pass = false;
                  }
                }
                if (pass) {
                  modal.destroy();
                  for (let i = 0; i < kd.chartdata.rooms.length; ++i) {
                    if (room_id == kd.chartdata.rooms[i].id) {
                      kd.chartdata.rooms[i].name = value.fields[0];
                      break;
                    }
                  }
                  kd.update({
                    _id: chart_id,
                    domain: "chart",
                    rooms: kd.chartdata.rooms,
                  });
                } else {
                  const opt5 = {
                    position: "top",
                    width: "90%",
                    seconds: 3,
                    h1: l.translate("Template name already exists"),
                    body: l.translate(
                      "Please choose a unique name for this template."
                    ),
                    buttons: [
                      {
                        description: "ok",
                        value: "close",
                      },
                    ],
                  };
                  notification.create(opt5, {}, (err2, value2) => {
                    notification.destroy();
                  });
                }
              }
              break;
            case "deleteRoom":
              modal.destroy();
              if (kd.localstore.data.room === 1) {
                const opt2 = {
                  position: "top",
                  width: "90%",
                  seconds: 5,
                  h1: l.translate("Can not delete primary room"),
                  body: l.translate(
                    "You can not delete the primary room, but you can " +
                      "clear it. Touch the eraser icon to clear everything from this room."
                  ),
                  buttons: [
                    {
                      description: "ok",
                      value: "close",
                    },
                  ],
                };
                notification.create(opt2, {}, (err2, value2) => {
                  notification.destroy();
                });
              } else {
                for (let i = 0; i < kd.chartdata.rooms.length; ++i) {
                  if (room_id == kd.chartdata.rooms[i].id) {
                    kd.chartdata.rooms.splice(i, 1);
                    break;
                  }
                }
                const tables = kd.chartdata.tables;
                for (let i = tables.length - 1; i >= 0; --i) {
                  if (room_id == tables[i].room) {
                    tables.splice(i, 1);
                  }
                }

                kd.localstore.data.room = 1;

                kd.update({
                  _id: chart_id,
                  domain: "chart",
                  _kd: {
                    mergerule: "REPLACE",
                  },
                  rooms: Object.assign([], kd.chartdata.rooms),
                  tables,
                });
              }
              break;
            default: {
              modal.destroy();
              break;
            }
          }
        });
        break;
      }
      case "section": {
        template_id = kd.doc("location")[0].template;
        template_name = kd.doc("template", template_id)[0].name;

        const opt = {
          width: "90%",
          type: "dialog",
          h1: l.translate("Edit Template"),
          body: l.translate(
            "Please enter a new name for this template. You can " +
              "alternatively delete this template altogether."
          ),
          fields: [
            {
              description: template_name,
            },
          ],
          buttons: [
            {
              description: l.translate("Cancel"),
              value: "cancel",
            },
            {
              description: l.translate("Delete Template"),
              value: "deleteTemplate",
            },
            {
              description: l.translate("Rename Template"),
              value: "renameTemplate",
            },
          ],
        };

        const data = {
          kd,
        };
        modal.create(opt, data, (err, value) => {
          switch (value.button) {
            case "renameTemplate": {
              const templates = Object.assign(
                [],
                kd.find("template", {
                  $and: [{ active: 1 }, { chart: kd.location.chart }],
                })
              );
              let pass = true;
              for (let i = 0; i < templates.length; ++i) {
                if (value.fields[0] === templates[i].name) {
                  pass = false;
                }
              }
              if (pass) {
                modal.destroy();
                if (value.fields[0].length) {
                  kd.update({
                    _id: template_id,
                    domain: "template",
                    name: value.fields[0],
                  });
                }
              } else {
                const opt5 = {
                  position: "top",
                  width: "90%",
                  seconds: 3,
                  h1: l.translate("Template name already exists"),
                  body: l.translate(
                    "Please choose a unique name for this template."
                  ),
                  buttons: [
                    {
                      description: "ok",
                      value: "close",
                    },
                  ],
                };
                notification.create(opt5, {}, (err2, value2) => {
                  notification.destroy();
                });
              }
              break;
            }
            case "deleteTemplate": {
              modal.destroy();
              kd.update({
                _id: template_id,
                domain: "template",
                active: 2,
              })
                .then((result) => {
                  const template_id0 = kd.find("template", {
                    $and: [{ active: 1 }, { chart: kd.location.chart }],
                  })[0]._id;
                  return kd
                    .update({
                      domain: "location",
                      _id: kd.location._id,
                      template: template_id0,
                    })
                    .then((result2) => {
                      kd.emit("template.update", {});
                    })
                    .catch((err4) => {
                      console.log("err4", err4);
                    });
                })
                .catch((err5) => {
                  console.log("err5", err5);
                });

              break;
            }
            default: {
              modal.destroy();
              break;
            }
          }
        });
        break;
      }
      default:
        break;
    }
  });

  $("#layout_chart_reorder").fastClick((event) => {
    switch (currentConfig) {
      case "seatmap": {
        const options = {
          target_id: "layout_chart_reorder",
          type: "listsort",
          position: "bottom",
          highlight: null,
          adjust: {
            x: -48,
            y: -10,
          },
        };

        const chart_id = kd.doc("location")[0].chart;
        const rooms = kd.doc("chart", chart_id)[0].rooms;

        const sortitems = [];
        for (let i = 0; i < rooms.length; ++i) {
          sortitems.push({
            description: rooms[i].name,
            value: rooms[i].id,
          });
        }

        component.create(options, sortitems, (err, value) => {
          const sortnew = [];
          value.forEach((room) => {
            sortnew.push({
              id: room.value,
              name: room.description,
            });
          });
          kd.chartdata.rooms = sortnew;
          kd.update({
            _id: chart_id,
            domain: "chart",
            _kd: {
              mergerule: "REPLACE",
            },
            rooms: sortnew,
          });
        });
        break;
      }
      case "section": {
        const options = {
          target_id: event.target.id,
          type: "listsort",
          position: "bottom",
          highlight: null,
          adjust: {
            x: -48,
            y: -10,
          },
        };

        const templates = Object.assign(
          [],
          kd.find(
            "template",
            {
              $and: [{ active: 1 }, { chart: kd.location.chart }],
            },
            "order"
          )
        );

        const sortitems = [];
        templates.forEach((template) => {
          sortitems.push({
            description: template.name,
            value: template._id,
          });
        });

        component.create(options, sortitems, (err, value) => {
          const sortnew = [];
          value.forEach((template) => {
            sortnew.push({
              id: template.value,
              name: template.description,
            });
          });
          let order = 0;
          sortnew.forEach((sort2) => {
            kd.update({
              _id: sort2.id,
              domain: "template",
              order: ++order,
            });
          });
        });
        break;
      }
      default:
        break;
    }
  });

  // configuration dashbaord
  $(window).resize(() => {
    resize(kd);
  });

  TweenMax.to("#layout_configuration", 0, { alpha: 0, ease: Power2.easeOut });
  TweenMax.to("#layout_chart_editor", 0, { alpha: 0, ease: Power2.easeOut });
};

const resize = (kd) => {
  $("#layout_chart_editor").css("display", "none");
  $(".layout_chart_rooms_add").css("display", "none");
  $("#layout_chart_section").css("display", "none");
  $("#layout_chart_clear").css("display", "none");
  switch (kd.localstore.data.op_state) {
    case "standard":
      TweenMax.to("#layout_configuration", conf.vars.interfaceSpeed / 2, {
        height: $(window).height(),
        ease: Power2.easeOut,
      });
      TweenMax.to("#layout_configuration_body", conf.vars.interfaceSpeed / 2, {
        height: $(window).height() - headerHeight,
        ease: Power2.easeOut,
      });
      break;
    case "chart":
      $("#layout_chart_editor").css("display", "block");
      $(".layout_chart_rooms_add").css("display", "block");
      TweenMax.to("#layout_chart_editor", conf.vars.interfaceSpeed / 2, {
        alpha: 1,
        ease: Power2.easeOut,
      });
      TweenMax.to("#layout_configuration", conf.vars.interfaceSpeed / 2, {
        height: headerHeight,
        ease: Power2.easeOut,
      });
      TweenMax.to("#layout_configuration_body", conf.vars.interfaceSpeed / 2, {
        height: 0,
        ease: Power2.easeOut,
      });
      break;
    case "section":
      $("#layout_chart_section").css("display", "block");
      $(".layout_chart_rooms_add").css("display", "block");
      $("#layout_chart_clear").css("display", "none");
      TweenMax.to("#layout_chart_section", conf.vars.interfaceSpeed / 2, {
        alpha: 1,
        ease: Power2.easeOut,
      });
      TweenMax.to("#layout_configuration", conf.vars.interfaceSpeed / 2, {
        height: headerHeight,
        ease: Power2.easeOut,
      });
      TweenMax.to("#layout_configuration_body", conf.vars.interfaceSpeed / 2, {
        height: 0,
        ease: Power2.easeOut,
      });
      break;
    default:
      break;
  }
  $("#layout_chart_editor").css("height", `${conf.vars.viewportHeight - 50}px`);
  $("#layout_chart_section").css(
    "height",
    `${conf.vars.viewportHeight - 50}px`
  );
};

const open = (kd) => {
  $("#layout_configuration").css("display", "block");
  TweenMax.to("#layout_configuration", 0, {
    height: $(window).height(),
    ease: Power2.easeOut,
  });
  TweenMax.to("#layout_configuration_body", 0, {
    height: $(window).height() - headerHeight,
    ease: Power2.easeOut,
  });
  TweenMax.to("#layout_configuration", conf.vars.interfaceSpeed / 2, {
    alpha: 1,
    ease: Power2.easeOut,
  });
};

const closeWarn = (kd) => {
  const opt = {
    width: "80%",
    type: "dialog",
    h1: l.translate("Close configuration?"),
    body: l.translate(
      "Are you sure you want to close the configuration area? All unsaved " +
        "changes will be lost and will revert back to the previously saved state."
    ),
    buttons: [
      {
        description: l.translate("Cancel"),
        value: "cancel",
      },
      {
        description: l.translate("Yes, close"),
        value: "close",
      },
    ],
  };

  const data = {
    kd,
  };
  modal.create(opt, data, (err, value) => {
    modal.destroy();
    switch (value.button) {
      case "close":
        close(kd);
        break;
      default:
        break;
    }
  });
};

const close = (kd) => {
  chartClose(kd);
  kd.localstore.data.op_state = "standard";
  kd.emit("chart.update", {});
  $("#layout_configuration").css("display", "none");
  $(".layout_chart_rooms_add").css("display", "none");
  TweenMax.to("#layout_configuration", 0, { alpha: 0, ease: Power2.easeOut });
  TweenMax.to("#layout_chart_editor", 0, { alpha: 0, ease: Power2.easeOut });
};

const chartOpen = (kd) => {
  const options = {
    target_id: "layout_chart_editor_rectangle",
    type: "accordion",
    mode: "table",
    tables: conf.vars.tables,
  };

  const data = {
    kd,
  };

  accordion.create(options, data, (err, value) => {});
  layout.reset();
  chart.resetZoom();
  chart.disable();
  $("#layout_chart_template_select").css("display", "none");
  $(".layout_chart_rooms_add").css("display", "block");
  kd.localstore.data.op_state = "chart";
  kd.emit("chart.update", {});
  resize(kd);
};

const chartClose = (kd) => {
  chart.enable();
  kd.localstore.data.op_state = "standard";
  kd.emit("chart.update", {});
  resize(kd);
};

const sectionOpen = (kd) => {
  layout.reset();
  chart.resetZoom();
  $("#layout_chart_template_select").css("display", "block");
  $(".layout_chart_rooms_add").css("display", "none");
  kd.localstore.data.op_state = "section";
  kd.emit("chart.update", {});
  resize(kd);
};

const sectionClose = (kd) => {
  kd.localstore.data.op_state = "standard";
  kd.emit("chart.update", {});
  resize(kd);
};

const limitOpen = (kd) => {
  layout.reset();
  chart.resetZoom();
  // $('#layout_chart_template_select').css('display', 'block');
  // $('.layout_chart_rooms_add').css('display', 'none');
  $("#layout_reslimit_editor").css("display", "block");
  kd.localstore.data.op_state = "limit";
  reslimit.init(kd);
  setTimeout(() => {
    $("#layout_reslimit_limit_select").click();
    $("#component_catch").css("visibility", "hidden");
  }, 1000);
  setTimeout(() => {
    $("#dd1").click();
    $("#component_catch").css("visibility", "visible");
  }, 2000);
  // kd.emit('chart.update', {});
  resize(kd);
};

const limitClose = (kd) => {
  kd.localstore.data.op_state = "standard";
  kd.emit("chart.update", {});
  resize(kd);
};

module.exports = {
  init,
  open,
  close,
  chartOpen,
  sectionOpen,
  limitOpen,
};



/** WEBPACK FOOTER **
 ** ./src/controllers/configuration/index.js
 **/